import moment from "moment";
import React from "react";

const PayRateTable = ({dollarOpen}) => {
  return (
    <table className="">
      <thead>
        {/* , display:"flex",alignItems:"center", justifyContent:"flex-start" */}
        <tr
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(6,minmax(0,1fr))",
            rowGap: "0.5rem",
            columnGap: "0.5rem",
          }}
        >
          <th
            style={{ textTransform: "none", margin: "0rem", padding: "0rem" }}
          >
            Location
          </th>
          <th
            style={{ textTransform: "none", margin: "0rem", padding: "0rem" }}
          >
            Department
          </th>
          {dollarOpen?.shiftType === 2 && (
            <th
              style={{ textTransform: "none", margin: "0rem", padding: "0rem" }}
            >
              Appointment type{" "}
            </th>
          )}
          <th
            style={{ textTransform: "none", margin: "0rem", padding: "0rem" }}
          >
            Candidate hourly base rate{" "}
          </th>
          {dollarOpen?.shiftType !== 2 && (
            <th
              style={{ textTransform: "none", margin: "0rem", padding: "0rem" }}
            >
              {" "}
              Employer billing markup
            </th>
          )}
          <th
            style={{ textTransform: "none", margin: "0rem", padding: "0rem" }}
          >
            Employer hourly base rate
          </th>
          <th
            style={{ textTransform: "none", margin: "0rem", padding: "0rem" }}
          >
            Effective Date
          </th>
        </tr>
      </thead>
      <tbody style={{ rowGap: "0.5rem" }}>
        {Array.isArray(dollarOpen?.result) &&
          dollarOpen?.result?.map((item, index) => (
            <tr
              style={{
                color: item?.colourCode ? "green" : "red",
                display: "grid",
                gridTemplateColumns: "repeat(6,minmax(0,1fr))",
                rowGap: "0.5rem",
                columnGap: "0.5rem",
              }}
              key={index}
            >
              <td>{item?.locationName}</td>
              <td>{item?.departmentName}</td>
              {dollarOpen?.shiftType === 2 && <td>{item?.appointmentTypes}</td>}
              <td>{item?.hasRatePerHour ? `$${item?.hasRatePerHour}` : ""}</td>
              {dollarOpen?.shiftType !== 2 && (
                <td>{item?.markup ? item?.markup : ""}</td>
              )}
              <td>
                {dollarOpen.shiftType === 2
                  ? item?.employerHasRatePerHour
                    ? `$${item?.employerHasRatePerHour}`
                    : ""
                  : item?.hasRatePerHour
                  ? `$${(
                      parseFloat(item?.hasRatePerHour) *
                      parseFloat(item?.markup)
                    ).toFixed(2)}`
                  : ""}
              </td>
              <td>
                {(item?.effectiveDate && ((dollarOpen.shiftType === 2 && item?.employerHasRatePerHour && item?.hasRatePerHour) ||
                (dollarOpen?.shiftType !== 2 && item?.hasRatePerHour &&  item?.markup )))
                  ? moment(item?.effectiveDate).format("MM/DD/YYYY")
                  : ""}
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default PayRateTable;
